import React from 'react';
import { Tooltip, IconButton, Zoom } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Resume from '../../settings/resume.json';

const useStyles = makeStyles((theme) => ({
  socialIcons: {
    position: 'fixed',
    top: theme.spacing(6),
    right: theme.spacing(6),
    zIndex: 10000,
    display: 'flex',
    flexDirection: 'column',
    pointerEvents: 'auto',
  },
  iconButton: {
    height: '2.75rem',
    width: '2.75rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
    backgroundColor: 'transparent',
    boxShadow: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 10001,
    transition: 'transform 0.15s ease, background-color 0.15s ease',
    '&:hover': {
      transform: 'translateY(-4px) scale(1.03)',
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0 8px 28px rgba(0,0,0,0.16)',
    },
  },
  icon: {
    fontSize: '1.15rem',
    color: theme.palette.background.default === '#ffffff' ? theme.palette.text.primary : theme.palette.foreground?.default || theme.palette.text.primary,
    transition: 'color 0.2s ease',
    display: 'inline-block',
  },
  // platform color helpers
  platformGoogle: {
    color: '#DB4437',
  },
  platformLinkedIn: {
    color: '#0A66C2',
  },
  platformGithub: {
    color: theme.palette.type === 'dark' ? '#ffffff' : '#111111',
  },
  platformMedium: {
    color: '#000000',
  },
  platformLeetCode: {
    color: '#FFA116',
  },
  link: {
    textDecoration: 'none',
    color: 'inherit',
    display: 'block',
    zIndex: 10001,
    position: 'relative',
  },
}));

export const SocialIcons = () => {
  const classes = useStyles();

  const socialItems = Resume.basics.profiles.map((socialItem) => {
    let platformClass = '';
    if (socialItem.network === 'Google') platformClass = classes.platformGoogle;
    else if (socialItem.network === 'LinkedIn') platformClass = classes.platformLinkedIn;
    else if (socialItem.network === 'GitHub') platformClass = classes.platformGithub;
    else if (socialItem.network === 'Medium') platformClass = classes.platformMedium;
    else if (socialItem.network === 'LeetCode') platformClass = classes.platformLeetCode;

    const iconClassNames = `${classes.icon} ${platformClass} ${socialItem.x_icon}`;

    return (
      <Tooltip
        key={socialItem.network.toLowerCase()}
        title={socialItem.username}
        placement='left'
        TransitionComponent={Zoom}
      >
        <a
          href={socialItem.url}
          target='_blank'
          rel='noopener noreferrer'
          className={classes.link}
        >
          <IconButton
            color='inherit'
            aria-label={socialItem.network}
            className={classes.iconButton}
          >
            <i className={iconClassNames}></i>
          </IconButton>
        </a>
      </Tooltip>
    );
  });

  return <div className={classes.socialIcons}>{socialItems}</div>;
};
